import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function submitQuote(token: string, quote_id: string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('submitQuote')
    .setMethod('POST')
    .setProps([{token: token, quote_id: quote_id}])
    .send();
}
